import { getAuthHeader } from "utils/auth/helpers"
import { addMagentoEnvAuthHeaders } from "utils/magentoEnvAuthHeaders"

export interface CreatePaymentProfileBody {
  cardNumber?: string;
  expirationDate?: string;
  cardCode?: string;
  routingNumber?: string;
  accountNumber?: string;
  nameOnAccount?: string;
  firstName?: string;
  lastName?: string;
  address?: string;
  state?: string;
  zip?: string;
  city?: string;
}

export const createPaymentProfile = async ( data: CreatePaymentProfileBody, patientHash: string | null = null ) => {
  const response = await fetch( `${process.env.REACT_APP_LAMBDA_AUTHNET_PAYMENTS_URL}/v2/payment-profile`, {
    method: `POST`,
    headers: {
      'Content-Type': `application/json`,
      'Authorization': patientHash ?`PatientHash ${patientHash}` : getAuthHeader(),
      ...addMagentoEnvAuthHeaders()
    },
    body: JSON.stringify( data )
  })

  return await response.json()
}